import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { ToasterService } from 'src/app/services/toaster/toaster.service';
import { confimrPasswordValidator } from 'src/app/validators/confirm-password';
import { passwordValidator } from 'src/app/validators/password-validator';

enum paswordFieldTypesEnum {
  passwordInputType = 'passwordInputType',
  repeatPasswordInputType = 'repeatPasswordInputType'
}

@Component({
  selector: 'app-signup-modal',
  templateUrl: './signup-modal.component.html',
  styleUrls: ['./signup-modal.component.scss']
})
export class SignupModalComponent implements OnInit {
  acceptTermsAndConditions = false;
  passwordInputType = 'password';
  repeatPasswordInputType = 'password';
  passwordInputTypes = paswordFieldTypesEnum;
  signUpForm: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<SignupModalComponent>,
    private authServe: AuthService,
    private fb: UntypedFormBuilder,
    private toaster: ToasterService,
    private snackbar: MatSnackBar,
    private config: ConfigService,
  ) {
    this.signUpForm = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      mobileNumber: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      password: ['', [Validators.required, Validators.minLength(6), passwordValidator()]],
      matchingPassword: ['', [Validators.required, Validators.minLength(6)]],
      termsAndConditions: ['', Validators.required]
    }, { validators: confimrPasswordValidator('password', 'matchingPassword') });
  }

  ngOnInit(): void {
  }

  togglePasswordType(variableName: paswordFieldTypesEnum) {
    this[variableName] = this[variableName] === 'text' ? 'password' : 'text';
  }

  getSocialLoginURL(provider = ''): string {
    const url = `${this.config.API_BASE}/oauth2/authorization/${provider}?redirect_uri=${window.location.href}`;
    return url;
  }


  async signup(): Promise<void> {
    if (this.signUpForm.get('termsAndConditions')?.value === true) {
      try {
        const data = this.signUpForm.value;
        const res = await this.authServe.signUp(data);
        this.toaster.success(res.message ?? 'Signup successful');
        this.openLoginModal();
      } catch (error: any) {
        console.error(error);
        this.toaster.error(error?.error?.message ?? 'Failed to signup');
      }
    } else {
      this.acceptTermsAndConditions = !this.acceptTermsAndConditions;
      this.snackbar.open('Please accept Terms and Conditions', 'close', {duration: 2000});
    }

  }

  openLoginModal() {
    this.dialogRef.close({ openLogin: true });
  }
}
